import { combineReducers } from "redux";

import { reducer as formReducer } from "redux-form";

import {
  user,
  user4D,
  practitioner,
  patients,
  lastTenResults,
  allPatientOrders,
  patientOrderResults,
  //patientOrderResultsOne,//api
  patientHistoric,
  practitionerInfo,
  entityInfo,
  selectedPatient,
  selectedPractitioner,
  allPractitionersStore,
  allEntitiesStore,
  selectedEntity,
  allPasswordConfigurationsStore,
} from "./reducers/user";

import { entityRelations, userRelations } from "./reducers/entityRelations";
import { entityOrders } from "./reducers/ordersReducer";
import { graphsList } from "./reducers/graphsList";

import { cities } from "./reducers/citiesReducer";

import examReducer from "./reducers/examReducer";

export default combineReducers({
  user,
  cities,
  practitioner,
  user4D,
  patients,
  lastTenResults,
  allPatientOrders,
  patientOrderResults,
  //patientOrderResultsOne,//api
  patientHistoric,
  graphsList,
  practitionerInfo,
  selectedPatient,
  selectedPractitioner,
  allPractitionersStore,
  allEntitiesStore,
  selectedEntity,
  entityInfo,
  entityRelations,
  userRelations,
  entityOrders,
  allPasswordConfigurationsStore,
  examsByOrder: examReducer,
  form: formReducer,
});
